import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import useDailyReportFilterStore from "./store/useDailyReportFilterStore";
import { useDailyReportStore } from "./store/useDailyReportStore";
import { ExportDailyReport } from "./ExportsAttendanceSummary/ExportDailyReport";
import isGHMC, { getCurrentDate } from "../../../../Common/helper/helpar";
import { GetDesignations, GetOperations } from "../../../Attendance/AttendanceApis";
import { getNowDateTime, getOneMonthPastDate, getOneMonthPastDateTime, getTodayDate } from "../../../AssetVehicle/utils/helpers";

export const DailyReportFilterForm = () => {
  const isProd = isGHMC();
  const [operationsData, setOperationsData] = useState([]);
  const [designationsData, setDesignationsData] = useState([]);
  const currentDate = getCurrentDate()
  const {
    fetchDailyEmployeeAttendance,
    fetchPunchInLocations,
    fetchPunchOutLocations,
    punchInLocations,
    punchOutLocations,
  } = useDailyReportStore();

  const fetchInitialDropdowns = async () => {
    try {
      const [
        OperationsResponse,
        DesignationsResponse,
      ] = await Promise.all([
        GetOperations(),
        GetDesignations(),
      ]);
      setOperationsData(OperationsResponse.data);
      setDesignationsData(DesignationsResponse.data);
    } catch (error) {
      console.error("Error fetching Route data:", error.message);
    }
  }

  useEffect(() => {
    fetchPunchInLocations();
    fetchPunchOutLocations();
  }, [fetchPunchInLocations, fetchPunchOutLocations]);

  useEffect(() => {
    fetchInitialDropdowns()
    fetchDailyEmployeeAttendance(initialFilters);
  }, []);


  const initialFilters = {
    Date: currentDate,
    EmployeeId: "",
    OperationId: "",
    DesignationId: "",
    Jawaharnagar: "",
    PunchInLocation: "",
    PunchOutLocation: "",
  }

  const handleSubmit = (values) => {
    fetchDailyEmployeeAttendance(values);
  };

  const handleReset = (resetForm) => {
    resetForm();
    fetchDailyEmployeeAttendance(initialFilters);
  };

  return (
    <div>
      <Formik
        enableReinitialize
        initialValues={initialFilters}
        onSubmit={handleSubmit}
      >
        {({ resetForm, values }) => (
          <Form>
            <div className="row d-flex align-items-center mb-3">
              <div className="col-md-2 mb-3">
                <label className="form-label w-100">Date</label>
                <Field
                  type="date"
                  name="Date"
                  className="form-control"
                  placeholder="Enter Date"
  min={getOneMonthPastDate()}
  max={getTodayDate()}
                />
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label w-100">Emp ID</label>
                <Field
                  type="text"
                  name="EmployeeId"
                  className="form-control"
                  placeholder="Enter Emp ID"
                />
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label w-100">Operations</label>
                <Field
                  as="select"
                  name="OperationId"
                  className="form-select"
                >
                  <option value="">Select</option>
                  {operationsData.filter(operation => operation.isActive === true).map((operation) => (
                    <option key={operation.operationId} value={operation.operationId}>
                      {operation.operationName}
                    </option>
                  ))}
                </Field>
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label w-100">Designation</label>
                <Field
                  as="select"
                  name="DesignationId"
                  className="form-select"
                >
                  <option value="">Select</option>
                  {designationsData.filter(designation => designation.isActive && designation.operationId == values.OperationId).map((designation) => (
                    <option key={designation.designationId} value={designation.designationId}>
                      {designation.designationName}
                    </option>
                  ))}
                </Field>
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label w-100">Jawahar Nagar</label>
                <Field as="select" name="Jawaharnagar" className="form-select">
                  <option value="">Select</option>
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </Field>
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label w-100">Punch In Location</label>
                <Field
                  as="select"
                  name="PunchInLocation"
                  className="form-select"
                >
                  <option value="">Select Punch In Location</option>
                  {values.Jawaharnagar === "true"
                    ? punchInLocations[0]?.jawaharnagar?.split(",").map((location, index) => (
                      <option key={index} value={location}>
                        {location}
                      </option>
                    )) : punchInLocations[0]?.others?.split(",").map((location, index) => (
                      <option key={index} value={location}>
                        {location}
                      </option>
                    ))}
                </Field>
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label w-100">Punch Out Location</label>
                <Field
                  as="select"
                  name="PunchOutLocation"
                  className="form-select"
                >
                  <option value="">Select Punch Out Location</option>
                  {values.Jawaharnagar === "true"
                    ? punchOutLocations[0]?.jawaharnagar?.split(",").map((location, index) => (
                      <option key={index} value={location}>
                        {location}
                      </option>
                    )) : punchOutLocations[0]?.others?.split(",").map((location, index) => (
                      <option key={index} value={location}>
                        {location}
                      </option>
                    ))}
                </Field>
              </div>
              <div className="col-md-4 mt-2 d-flex gap-2 ml-auto">
                <button type="submit" className={`btn  ${isProd ? "search-ghmc" : "search-swm"}`}>
                  Search
                </button>
                <button
                  type="reset"
                  // className="btn btn-danger ml-2"
                  className={`btn  ${isProd ? "search-ghmc" : "search-swm"}`}
                  onClick={() => handleReset(resetForm)}
                >
                  Reset
                </button>
                <ExportDailyReport />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};
